import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  nextPage,
  prevPage,
  sidebarToggle,
  svgScaleDown,
  svgScaleReset,
  svgScaleUp,
  updateIsBasketVisible,
  updatePage
} from '../../store/actions/config.actions';
import { CONFIG } from '../../store/reducer/config.reducer';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: false
})
export class NavComponent {
  config$: Observable<any> = this.store.select((state) => state.config);
  basket$: Observable<any> = this.store.select((state) => state.basket);

  constructor(private store: Store<{ config: CONFIG; basket: {} }>) {}

  scaleUp() {
    this.store.dispatch(svgScaleUp());
  }
  scaleDown() {
    this.store.dispatch(svgScaleDown());
  }
  prevPage() {
    this.store.dispatch(prevPage());
    this.store.dispatch(svgScaleReset());
  }
  nextPage() {
    this.store.dispatch(nextPage());
    this.store.dispatch(svgScaleReset());
  }
  sidebarToggle() {
    this.store.dispatch(sidebarToggle());
  }
  openBasket() {
    this.store.dispatch(updateIsBasketVisible());
  }

  openHome() {
    this.store.dispatch(updatePage(0));
  }

  fullScreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      const partsView = document.querySelector('app-part-view') as any;
      (
        partsView?.requestFullscreen ||
        partsView?.webkitRequestFullscreen ||
        partsView?.mozRequestFullScreen ||
        partsView?.msRequestFullscreen
      )?.call(partsView);
      this.store.dispatch(sidebarToggle(false));
      this.store.dispatch(updateIsBasketVisible(false));
    }
  }
}
